/**
 * The first `max` characters of free text on one line, with an ellipsis when cut — how a
 * confirmation names a note or a transcript (TMMAPP-0071).
 */
export function excerpt(text: string, max = 40): string {
  const line = text.replace(/\s+/g, ' ').trim();
  return line.length <= max ? line : `${line.slice(0, max).trimEnd()}…`;
}
